/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";

const dest = createAccessors("hybridspace-onboarding-module", createStore("hybridspace-onboarding-module", {
    shouldRunOnboardingExperience: false,
}));
const setShouldRunOnboardingExperience: (newValue: boolean) => void = dest.setShouldRunOnboardingExperience;
const getShouldRunOnboardingExperience: () => boolean = dest.getShouldRunOnboardingExperience;

export { setShouldRunOnboardingExperience, getShouldRunOnboardingExperience };
